<template>
  <div id="detailePage" class="modal" :style="{ display: (openDialog ? 'block' : 'none') }" v-if="winner">
    <header>

        
        <div class="detailePageTitle" >
          <div class="detailePageClose">
              <a href="javascript:void(0);" @click="close"><img class="mark10sen" src="/img/close.png" srcset="/img/close@2x.png 2x" alt=""/></a>
          </div>
          <!-- 100景 -->
          <div class="detailePageTitleTxt" v-if="winner && winner.awardType == EnumAwardTypeJapan100Views">
            <h1>{{this.winningWork && this.winningWork.shootingPlace}}</h1>
            <h2><b class="winnerLine1">{{this.winningWork && this.winningWork.shootingSpotName}}</b><b class="winnerSpacer">&nbsp;&nbsp;<span>|</span>&nbsp;&nbsp;</b><b class="winnerLine2">{{this.winner && this.winner.name}}</b></h2>
          </div>
          <!-- 協賛 -->
          <div class="detailePageTitleTxt" v-else-if="winner && winner.awardType == EnumAwardTypeSpecialExhibitons">
            <h1>{{this.winningWork && this.winningWork.title}}</h1>
            <h2><b class="winnerLine1">{{this.winner && this.winner.name}}</b><b class="winnerSpacer">&nbsp;&nbsp;<span>|</span>&nbsp;&nbsp;</b><b class="winnterLine2">{{this.winningWork && this.winningWork.photographer}}</b></h2>
          </div>
          <!-- 「城と月」特別部門 -->
          <div class="detailePageTitleTxt" v-else-if="winner && winner.awardType == EnumAwardTypeCastleAndMoon">
            <h1>{{this.winningWork && this.winningWork.shootingPlace}}</h1>
            <h2><b class="winnerLine1">{{this.winningWork && this.winningWork.shootingSpotName}}</b><b class="winnerSpacer">&nbsp;&nbsp;<span>|</span>&nbsp;&nbsp;</b><b class="winnerLine2">{{this.winner && this.winner.name}}</b></h2>
          </div>
          <!-- Monogatary -->
          <div class="detailePageTitleTxt" v-else-if="winner && winner.awardType == EnumAwardTypeMonogatary">
            <h1>{{this.winningWork && this.winningWork.shootingPlace}}</h1>
            <h2><b class="winnerLine1">{{this.winningWork && this.winningWork.shootingSpotName}}</b><b class="winnerSpacer">&nbsp;&nbsp;<span>|</span>&nbsp;&nbsp;</b><b class="winnerLine2">{{this.winner && this.winner.name}}</b></h2>
          </div>
          <div class="detailePageTitleTxt" v-else>
            <h1>{{this.winningWork && this.winningWork.title}}</h1>
            <!-- JTG -->
            <template v-if="winner.awardType === EnumAwardTypeJtg">
              <h2><b class="winnerLine1">Japan Travel Gallery Photo Contest 2022</b><b class="winnerSpacer">&nbsp;&nbsp;<span>|</span>&nbsp;&nbsp;</b><b class="winnerLine2">{{this.winner && this.winner.name}}</b></h2>
            </template>
            <!-- Weibo -->
            <template v-else-if="winner.awardType === EnumAwardTypeWeibo">
              <h2><b class="winnerLine1">Weibo</b><b class="winnerSpacer">&nbsp;&nbsp;<span>|</span>&nbsp;&nbsp;</b><b class="winnerLine2">{{this.winner && this.winner.name}}</b></h2>
            </template>
            <!-- Twitter -->
            <template v-else-if="winner.awardType == EnumAwardTypeTwitter">
              <h2><b class="winnerLine1">「ご当地グルメ」on Twitter</b><b class="winnerSpacer">&nbsp;&nbsp;<span>|</span>&nbsp;&nbsp;</b><b class="winnerLine2">{{this.winner && this.winner.name}}</b></h2>
            </template>
            <!-- Instagram -->
            <template v-else-if="winner.awardType == EnumAwardTypeInstagram">
              <h2><b class="winnerLine1">Instagram部門（３×３）</b><b class="winnerSpacer">&nbsp;&nbsp;<span>|</span>&nbsp;&nbsp;</b><b class="winnerLine2">{{this.winner && this.winner.name}}</b></h2>
            </template>
            <!-- 10選 -->
            <template v-else>
              <h2><b class="winnerLine1">{{this.winner && this.awardTypeNames[this.winner.awardType]}}</b><b class="winnerSpacer">&nbsp;&nbsp;<span>|</span>&nbsp;&nbsp;</b><b class="winnerLine2">{{this.winner && this.winner.name}}</b></h2>
            </template>
          </div>
        </div>

        <div class="detailePageMenu" >
          <ShareButton ulClassName="detailePageSnsShareBtn" message="この作品ページをシェア" />
        </div>

    </header>
    <div id="mainDetailePage">
      <div class="inner3" style="position: relative;">
          <div class="photoArea" :class="{ adjustPositionPhotoArea: isImageOnly() }">

          <div class="twitterPosterBody">
            <div class="photoImage" :style="{width: frameWidth + 'px', height: frameHeight + 'px'}">
                <img src="" @load="loadComplete" ref="imageData" :alt="winner && winner.awardType == EnumAwardTypeJapan100Views ? winningWork && winningWork.shootingPlace : winningWork && winningWork.title">
            </div>
          </div>

              <div class="photoImageMenuArea" v-if="isLoaded">
                <div class="imageMenu">
                  <a class="ui" href="javascript:void(0);" @click="zoom">拡&nbsp;&nbsp;大</a>
                </div>
                <img v-if="winningWork && winningWork.isSelection" class="mark10sen" src="/img2022/10v2021.png" srcset="/img2022/10v2021@2x.png 2x" alt=""/>
              </div>
          </div><!-- /photoArea-->

          <div v-if="!isLoaded" class="loadingBox">
            <img src="/img/loading.svg" style="width: 96px; height: 96px; display: block; filter: blur(0px);" />
          </div>
          <div class="photoInfo" :class="{ adjustPositionPhotoInfo: isImageOnly() }">
            <div v-if="isCommentaryExists()" class="exhCommentary">
              <div class="exhCommentaryHead">
                <h3>作品解説</h3>
                <a v-if="isCommentExists() && isCommentTabOn()" :class="{ location: currentCommentaryType === 'comment' }" href="javascript:void(0);" @click="changeComentaryTab('comment')">テキスト</a>
                <a v-if="isMovieExists() && isMovieTabOn()" :class="{ location: currentCommentaryType === 'movie' }" href="javascript:void(0);" @click="changeComentaryTab('movie')">動画</a>
              </div>

              <div class="exhCommentaryBody">
                <div v-if="isCommentExists() && currentCommentaryType === 'comment'" class="exhCommentaryTxt" :class="{ enText: winner.awardType === EnumAwardTypeJtg || winner.id === 600002 }">
                  <p>{{winningWorkIntroduction && winningWorkIntroduction.comment}}</p>
                </div>
                <div v-if="isMovieExists() && currentCommentaryType === 'movie'" class="exhCommentaryMovie">
                  <iframe width="320" height="180" :src="convertYoutubeUrl(winningWorkIntroduction.youtubeUrl)" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              </div>

              <div class="exhCommentaryBody1024">
                <div v-if="isCommentExists()" class="exhCommentaryTxt">
                  <p>{{winningWorkIntroduction && winningWorkIntroduction.comment}}</p>
                </div>
                <div v-if="isMovieExists()" class="exhCommentaryMovie" :style="{width: (isMovieExists() && !isMovieTabOn()) ? '100%' : 'auto'}">
                  <iframe width="320" height="180" :src="convertYoutubeUrl(winningWorkIntroduction.youtubeUrl)" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              </div>

            </div><!-- /exhCommentary-->

            <!-- 関連リンク -->
            <div v-if="winner && winningWorkIntroduction && winningWorkIntroduction.link1Url">
              <div class="relatedLink">
                <div class="relatedLinkHead">
                  <h3>関連リンク</h3>
                </div>
                <p class="relatedLinkBody">
                  <a v-on:click="externalLinkConfirm" :href="winningWorkIntroduction.link1Url" target="_blank" rel="noopener noreferrer">{{winningWorkIntroduction.link1Text ? winningWorkIntroduction.link1Text : winningWorkIntroduction.link1Url}}</a>
                </p>
              </div>
            </div>
            <div v-if="winner && winningWorkIntroduction && winningWorkIntroduction.link1Url">
              <div class="relatedLink1024">
                <div class="relatedLinkHead">
                  <h3>関連リンク</h3>
                </div>
                <p class="relatedLinkBody">
                  <a v-on:click="externalLinkConfirm" :href="winningWorkIntroduction.link1Url" target="_blank" rel="noopener noreferrer">{{winningWorkIntroduction.link1Text ? winningWorkIntroduction.link1Text : winningWorkIntroduction.link1Url}}</a>
                </p>
              </div>
            </div><!-- /関連リンク-->
          </div><!-- /photoInfo-->
      </div><!-- /inner-->
    </div><!-- /mainDetailePage-->
    <footer>
      <div class="inner3" v-show="isLoaded">
        <div class="copyright">
          Copyright &copy; Tokyo Camera Club Corp. All Rights Reserved.
        </div><!-- #copyright -->
      </div>
    </footer>

    <ExternalSiteAlertDialog
      :isOpen.sync="isExternalSiteAlertOpen"
      :link="externalSiteLink"
      :isSpecial="isSpecial"
    ></ExternalSiteAlertDialog>
  </div>
</template>

<script>
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import YoutubeUtil from '@/util/YoutubeUtil'
import Viewer from 'viewerjs'
import ShareButton from '@/components/modules/ShareButton'
import ExternalSiteAlertDialog from '@/components/modules/ExternalSiteAlertDialog.vue'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    ShareButton,
    ExternalSiteAlertDialog
  },
  props: [
    'isOpen',
    'winner',
    'winningWork',
    'commentaryType'
  ],
  data () {
    return {
      viewer: null,
      frameWidth: 0,
      frameHeight: 0,
      aspectRatio: 0,
      zoomRatio: 0,
      dialogOpen: false,
      isZoom: false,
      isZoomMin: true,
      isZoomMax: false,
      options: {
        inline: false,
        button: true,
        navbar: false,
        title: false,
        toolbar: true,
        play: false,
        prev: false,
        next: false,
        rotateLeft: false,
        rotateRight: false,
        tooltip: true,
        movable: true,
        zoomable: true,
        rotatable: false,
        scalable: false,
        transition: true,
        fullscreen: false,
        keyboard: false,
        backdrop: true,
        zoomRatio: 0.3,
        maxZoomRatio: 1,
        minZoomRatio: 0.01, // closeの際にリセットしてるので注意
        zIndex: 99999,
        toggleOnDblclick: false
      },
      winningWorkIntroduction: null,
      currentCommentaryType: null,
      isLoaded: false,
      isExternalSiteAlertOpen: false, // 外部サイトリンク警告ダイアログ表示制御フラグ
      externalSiteLink: null, // 外部サイトリンク
      isSpecial: false, //特別展示か
      audioUrl: process.env.VUE_APP_AUDIO_URL
    }
  },
  computed: {
    openDialog: {
      get () {
        return this.isOpen
      },
      set (value) {
        this.$emit('update:isOpen', value)
      }
    }
  },
  methods: {
    // 画像情報のみの場合true
    isImageOnly () {
      return !(this.winner && this.winner.isCommentWorks) && !this.isCommentaryExists()
    },
    loadComplete () {
      this.setImageSize()
      this.isLoaded = true
      this.viewer = new Viewer(this.$refs.imageData, this.options) // 表示開始時にはインスタンスを新規生成
    },
    setImageSize () {
      // 基準値
      let standardWidth = 830
      let standardHeight = 840
      if (document.documentElement.clientWidth < 840) {
        standardWidth = Math.round(document.documentElement.clientWidth * 0.9) // 画面の横幅に対する比率
        standardHeight = Math.round(standardWidth * 1.012) // 縦は横の場合より1.012倍大きい
      }
      // 初期表示レシオの計算と表示位置の調整
      if (!this.winningWork) return
      if (this.winningWork.width > this.winningWork.height) {
        // 横位置画像の場合の計算
        // 縦横比率の計算
        this.aspectRatio = (this.winningWork.height / this.winningWork.width)
        // 表示エリアの計算
        this.frameWidth = standardWidth // 横位置の基準値
        this.frameHeight = Math.round(this.frameWidth * this.aspectRatio)
        // 初期表示倍率の計算
        this.zoomRatio = this.frameWidth / this.$refs.imageData.naturalWidth
      } else {
        // 横位置画像の場合の計算
        // 縦横比率の計算
        this.aspectRatio = (this.winningWork.width / this.winningWork.height)
        // 表示エリアの計算
        this.frameHeight = standardHeight // 縦位置の基準値
        this.frameWidth = Math.round(this.frameHeight * this.aspectRatio)
        // 初期表示倍率の計算
        this.zoomRatio = this.frameHeight / this.$refs.imageData.naturalHeight
      }
      this.options.minZoomRatio = this.zoomRatio
      // 実画面サイズが小さい場合、画面サイズから、ズーム時の最小値を求める
      if (document.documentElement.clientWidth < 1000 || document.documentElement.clientHeight < 1000) {
        if (document.documentElement.clientWidth < document.documentElement.clientHeight) {
          this.options.minZoomRatio = document.documentElement.clientWidth * 0.7 / this.$refs.imageData.naturalWidth
        } else {
          this.options.minZoomRatio = document.documentElement.clientHeight * 0.7 / this.$refs.imageData.naturalHeight
        }
      }
    },
    inited (viewer) {
      this.viewer = viewer
      this.viewer.update() // 画像の状態を更新
    },
    reset () {
      this.viewer.zoomTo(this.zoomRatio)
      this.viewer.moveTo(0, 0)
      this.options.minZoomRatio = this.zoomRatio

      // イベント記録
      this.$ga.event('Image', 'zoomReset', this.awardTypeNames[this.winner.awardType], this.winningWork.id)
    },
    // viewerjsの機能を使用して最大化
    zoom () {
      let event = new Event("click")
      this.$refs.imageData.dispatchEvent(event)
    },
    close () {
      this.openDialog = false
      this.isLoaded = false
      this.options.minZoomRatio = 0.01 // この値は操作中に変更されるので、closeの際にリセットしている

      // 現行画像の非表示
      this.$refs.imageData.src = ''

      // インスタンスの破棄
      if (this.viewer) {
        this.viewer.destroy()
      }

      // 一覧ページへURL書き換え
      const index = this.$route.path.indexOf('/images/')
      if (index >= 0) {
        const urlPath = this.$route.path.substring(0, index)
        this.$router.push(urlPath)
      }
    },
    changeComentaryTab (commentaryType) {
      this.currentCommentaryType = commentaryType
    },
    isCommentaryExists () {
      return (
        this.winningWork && this.winningWork.winningWorkIntroduction && (
          this.winningWork.winningWorkIntroduction.comment ||
          this.winningWork.winningWorkIntroduction.youtubeUrl
        )
      )
    },
    isCommentExists () {
      return (
        this.winningWork && this.winningWork.winningWorkIntroduction &&
        this.winningWork.winningWorkIntroduction.comment
      )
    },
    isCommentTabOn () {
      // コメントタブはコメントのみしか無い状況では非表示とする
      return (
        !(this.isCommentExists() || (!this.isMovieExists())) ||
        (this.isCommentExists() && (this.isMovieExists()))
      )
    },
    isMovieExists () {
      return (
        Boolean(
          this.winningWork && this.winningWork.winningWorkIntroduction &&
          this.winningWork.winningWorkIntroduction.youtubeUrl
        )
      )
    },
    isMovieTabOn () {
      // movieタブはmovieのみしか無い状況では非表示とする
      return (
        !(this.isMovieExists() || (!this.isCommentExists())) ||
        (this.isMovieExists() && (this.isCommentExists()))
      )
    },
    convertYoutubeUrl (url) {
      return YoutubeUtil.getEmbedUrl(url)
    },
    windowResizeHandler () {
      this.setImageSize()
    },
    // 表示処理実行
    openImageViewer () {
      this.winningWorkIntroduction = this.winningWork.winningWorkIntroduction
      this.$refs.imageData.src = this.winningWork.imageUrlL

      // 作品解説のデフォルトタブ設定
      this.currentCommentaryType = this.commentaryType
      if (!this.currentCommentaryType) {
        if (this.isCommentExists()) {
          this.currentCommentaryType = 'comment'
        } else if (this.isMovieExists()) {
          this.currentCommentaryType = 'movie'
        }
      }

      // イベント記録
      this.$ga.event('Image', 'open', this.awardTypeNames[this.winner.awardType], this.winningWork.id)
    },
    // 外部リンク遷移時の警告ダイアログを表示
    externalLinkConfirm (e) {
      this.isSpecial = (this.winner.awardType == this.EnumAwardTypeSpecialExhibitons) ? true : false
      this.isExternalSiteAlertOpen = true
      this.externalSiteLink = e.srcElement.href
      
      e.preventDefault() // リンク先へ遷移しないよう制御
      return
    }
  },
  watch: {
    isOpen: function (value) {
      if (value) {
        this.openImageViewer() // 表示
      }
    },
    '$route.path': function (val, oldVal) {
      // '/images/'が含まれていたURLから '/images/'が含まれないURLに変わった場合は、画面が遷移したと判定しclose処理
      const index = val.indexOf('/images/')
      const oldIndex = oldVal.indexOf('/images/')
      if (oldIndex >= 0 && index < 0) {
        this.close()
      }
    }
  },
  created () {
  },
  mounted () {
    window.addEventListener('resize', this.windowResizeHandler)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.windowResizeHandler)
  }
}
</script>

<style scoped>
.modal {
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  overflow-y: auto;
  display: none;
  opacity: 1;
  background-color: white;
  z-index: 9999;
  /* border: solid 1px red; */
}

.loadingBox {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 64px;
  max-width: 830px;
  width: 100%;
}

</style>
